export const ORDER_STATUS = {
    DRAFT: {
        id: 1,
        code: 'Draft'
    },
    COMPLETE: {
        id: 2,
        code: 'Complete'
    },
    SCHEDULED: {
        id: 3,
        code: 'Scheduled'
    },
    ERROR: {
        id: 4,
        code: 'Error'
    },
    SENT: {
        id: 5,
        code: 'Sent'
    }
}